import { Link } from "react-router-dom";
import { getFilmById } from "@/lib/films";

const picks = [
  {
    film: getFilmById("midnight-harbour"),
    label: "经典重读",
    title: "九十年代的雨夜与码头",
    desc: "从胶片质感到长镜头调度，八部经典作品带你理解那个年代的表达方式：克制、留白，把情绪藏在潮水与霓虹里。",
    href: "/category?type=classic",
    cta: "进入经典片单",
  },
  {
    film: getFilmById("rose-parlour"),
    label: "新作专题",
    title: "近五年，题材变得更锋利",
    desc: "新一批创作者把镜头对准都市关系与心理悬疑，叙事节奏更快，视听语言也更强调空间与光线的对比。",
    href: "/category?type=latest",
    cta: "查看最新上映",
  },
];

export default function FeaturePicks() {
  return (
    <section className="w-full border-y border-background-300 bg-background-100">
      <div className="mx-auto w-full max-w-[1440px] px-4 py-14 md:px-8 md:py-20 lg:px-12">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="font-label text-[11px] uppercase tracking-[0.28em] text-accent-500">Editor&apos;s picks</p>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">编辑精选专题</h2>
          </div>
          <p className="max-w-md font-body text-sm leading-relaxed text-foreground-600">
            两条不同的观看线索：一条往回看经典，一条往前走看新作。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 lg:grid-cols-2 lg:gap-6">
          {picks.map((pick, index) =>
            pick.film ? (
              <article
                key={pick.label}
                className="group flex animate-rise flex-col overflow-hidden rounded-lg border border-background-300 bg-background-50 sm:flex-row"
                style={{ animationDelay: `${index * 90}ms` }}
              >
                <div className="relative h-[220px] w-full shrink-0 overflow-hidden sm:h-auto sm:w-[42%]">
                  <img
                    src={pick.film.poster}
                    alt={`《${pick.film.title}》专题配图`}
                    title={`${pick.film.title} 专题`}
                    className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-[1.05]"
                  />
                  <span className="absolute left-3 top-3 rounded-full bg-background-50/85 px-2.5 py-1 font-label text-[11px] text-accent-500 backdrop-blur-sm">
                    {pick.label}
                  </span>
                </div>
                <div className="flex flex-1 flex-col justify-center p-5 md:p-7">
                  <h3 className="font-heading text-lg font-bold leading-snug text-foreground-950 md:text-xl">
                    {pick.title}
                  </h3>
                  <p className="mt-3 font-body text-sm leading-relaxed text-foreground-600">{pick.desc}</p>
                  <div className="mt-5 flex items-center gap-3">
                    <Link
                      to={pick.href}
                      className="flex h-9 items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 font-label text-xs text-foreground-950 transition-colors hover:bg-primary-600"
                    >
                      {pick.cta}
                      <i className="ri-arrow-right-line" />
                    </Link>
                    <Link
                      to={`/detail/${pick.film.id}`}
                      className="font-label text-xs text-foreground-600 transition-colors hover:text-accent-500"
                    >
                      代表作品：《{pick.film.title}》
                    </Link>
                  </div>
                </div>
              </article>
            ) : null
          )}
        </div>
      </div>
    </section>
  );
}